import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RuleEditor from './RuleEditor';
import { fetchTargetByName } from 'redux/targetFields/TargetFieldsActions';
import { validateRule, fetchSubtypes, validationRuleReset } from 'redux/rules/RulesActions';

const mapStateToProps = ({ targetFields, rules }) => ({
  creatingRule: rules.creatingRule,
  targetFields: targetFields.fields,
  validationResult: rules.validationResult,
  validatingRule: rules.validatingRule,
  subtypes: rules.subtypes
});

const mapDispatchToProps = dispatch => ({
  targetActions: bindActionCreators({ fetchTargetByName }, dispatch),
  rulesActions: bindActionCreators({ validateRule, fetchSubtypes, validationRuleReset }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RuleEditor);



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/RuleEditorConnector.js